import React, { useEffect } from 'react';
import AuthLayout from '../auth-layout';
import useLetsGetStartedContext from 'contexts/lets-get-started.context';
import { Input } from '@cokitchen/cokitchen-components';

const PersonalDetails = () => {
  const { personalInfoFormData, setPersonalInfoFormData, setDisabled } = useLetsGetStartedContext();
  const inputFields = [
    {
      label: 'First name',
      placeholder: 'First name',
      name: 'first_name',
      className: 'mb-[28px]',
      value: personalInfoFormData.first_name,
      error:
        personalInfoFormData.first_name.length > 0 && personalInfoFormData.first_name.length < 3
          ? 'First name should have more than three characters'
          : ''
    },
    {
      label: 'Last name',
      placeholder: 'Last name',
      name: 'last_name',
      className: 'mb-[28px]',
      value: personalInfoFormData.last_name,
      error:
        personalInfoFormData.last_name.length > 0 && personalInfoFormData.last_name.length < 3
          ? 'Last name should have more than three characters'
          : ''
    },
    {
      label: 'Email',
      placeholder: 'Email',
      name: 'email',
      className: 'mb-[28px]',
      value: personalInfoFormData.email
    },
    {
      label: 'Phone number',
      placeholder: 'Phone number',
      name: 'phone_number',
      className: 'mb-[28px]',
      value: personalInfoFormData.phone_number,
      type: 'phone' as const,
      optional: true
    }
  ];

  const updateFormData = (name: string, value: string) => {
    setPersonalInfoFormData({ ...personalInfoFormData, [name]: value });
  };

  useEffect(() => {
    const { first_name, last_name, email } = personalInfoFormData;
    if (first_name.length >= 3 && last_name.length >= 3 && email) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [personalInfoFormData]);

  return (
    <div>
      <AuthLayout
        title={`Let's get you started`}
        subtitle='Ensure to provide correct details for all steps'
        onConfirmText='Continue'
        hideButton>
        {inputFields?.map(
          ({ label, placeholder, name, className, value, type, error, optional }, index) => (
            <Input
              design='bordered'
              error={error}
              key={index}
              label={label}
              placeholder={placeholder}
              value={value}
              onChange={(e) => updateFormData(name, e.target.value)}
              className={className}
              type={type}
              optional={optional}
            />
          )
        )}
      </AuthLayout>
    </div>
  );
};

export default PersonalDetails;
